<template>

<div class="corpo-pagina">
    <div class="row row-text">
      <div class="col s12">
        <h4>{{ this.translationStore.getters.traduzione('title.activation.account') }}!</h4>
      </div>
    </div>
<div class="divider"></div>
    <div class="row row-text">
      <div class="col s12">
        <p>{{ this.translationStore.getters.traduzione('accounte.activate.correcly') }}</p>
      </div>
    </div>

    <div class="row row-text">
      <div class="col s12">
        <p><a class="link-igotu" href="/login"> {{ this.translationStore.getters.traduzione('link.login.page') }}</a></p>
      </div>
    </div>
</div>

</template>
<script>
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'

export default {
  data () {
    return {
      translationStore: translationStore
    }
  },
  methods: {},
  computed: {
    traduzione () {
      return this.translationStore.getters.traduzione
    },

    // Nuova computed property per accedere ai dati della lingua corrente in modo sicuro
    currentLanguageData () {
      const currentCode = this.translation.getters.linguaCorrente
      const availableLanguages = this.translation.getters.avaiable
      // Restituisce l'oggetto lingua solo se esiste, altrimenti null o un oggetto vuoto
      return availableLanguages && availableLanguages[currentCode] ? availableLanguages[currentCode] : null
    }
  },

  mounted () {
    loadingStore.commit('setLoading', false)
  }

}
</script>
